import React from "react";
import HeroImage from "./../assets/arshad_image.jpg"
const About = () => {
  return (
    <div
      name="about"
      className="w-full   bg-gradient-to-b from-gray-800 to-black text-white "
    >
      <div className="w-[90%] mx-auto flex flex-col items-center justify-between   md:flex-row py-24 pr-16">
        <div className="flex flex-col justify-center p-2 ">
          <h2 className="text-4xl sm:text-7xl font-bold text-white">
            About
          </h2>
          <p className="text-gray-500 py-4 max-w-md">
            I have 2 years of experience building and desgining software.
            Currently, I love to work on web application using technologies like
            React, Tailwind, Thymeleaf, Bootstrap, Node and Jbake.
          </p>

          
        </div>

        <div>
          <img
            src={HeroImage}
            alt="my profile"
            className="rounded-2xl mx-auto w-full md:w-[300px] h-[300px]"
          />
        </div>
      </div>
    </div>
  );
};

export default About;
